<template>
  <v-card :loading="loading" class="mt-5" flat>
    <v-col class="pa-2 mt-4 mx-auto" cols="12" sm="8">
      <v-select
        v-model="selectedInventPhones"
        :disabled="!inventPhones || !inventPhones.length"
        :items="inventPhones"
        :menu-props="{ offsetY: true }"
        dense
        hide-details
        item-value="id"
        label="انتخاب مشاوران"
        multiple
        outlined
      >
        <template v-slot:prepend-item>
          <v-list-item ripple @click="toggle" @mousedown.prevent>
            <v-list-item-action>
              <v-icon
                :color="
                  selectedInventPhones.length > 0 ? 'indigo darken-4' : ''
                "
              >
                {{ icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title> انتخاب همه مشاوران </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
      </v-select>
    </v-col>

    <v-col class="mx-auto p-0" cols="12" sm="8">
      <v-btn
        :disabled="!inventPhones || !inventPhones.length"
        :loading="loading"
        class="text-white submit-btn"
        @click="getAdvertises"
      >
        <span class="material-icons ml-1" style="font-size: 14pt">save</span>
        بارگیری آگهی‌ها
      </v-btn>
    </v-col>

    <div
      v-if="!inventPhones || inventPhones.length > 0"
      class="p-0 mt-5 mb-3 pt-5 text-right"
      style="border: none !important"
    >
      <pay-ladder-component
        v-model="payLadder"
        :usersPanel="inventPanels"
        class="col-md-8 mx-auto"
        :phone="selectedNumber"
      />

      <categoryselector
        ref="category"
        :multiAdsCat="true"
        @category-schema="getSchema"
        @category-fields="getFields"
      />

      <div class="px-3 py-0 my-0">
        <similar-ads :adv="isSmart" :cats="myCategory" class="py-0 mb-5" />

        <div v-if="advertises.length > 0" class="col-md-10 mx-auto">
          <ads-l-ist
            :list="advertises"
            :market-number="marketNumber"
            :market-number-id="marketNumberId"
          />
        </div>
      </div>

      <div
        class="col-md-10 px-3 mx-auto py-0 my-0"
        style="border-top: 1px #7e8299 dashed"
      >
        <v-switch
          v-model="isDay"
          class="my-3"
          color="indigo darken-3"
          hide-details
          label="براساس تاریخ"
        />
      </div>

      <div
        v-for="(item, index) in count"
        v-if="isDay == true"
        class="col-md-10 px-3 mx-auto d-flex py-1"
      >
        <multi-times :key="item" :ref="item" />

        <v-btn
          class="mx-1 mr-2"
          color="success"
          icon
          outlined
          small
          @click="count.push(Math.random())"
        >
          <i class="fa fa-plus text-success" style="font-size: 9pt"></i>
        </v-btn>

        <v-btn
          v-if="count.length > 1"
          class="mx-1"
          color="error"
          icon
          outlined
          small
          @click="removeDate(index)"
        >
          <i class="fa fa-minus text-danger" style="font-size: 9pt"></i>
        </v-btn>
      </div>

      <div v-if="isDay === false" class="col-md-10 px-3 mx-auto py-1">
        <timr-with-days ref="withDays" />
      </div>

      <div class="row col-md-10 mx-auto px-0">
        <div class="col-md-6">
          <v-text-field
            v-model.number="newSchema['per']"
            :rules="[(v) => !!v || 'این فیلد الزامی است']"
            append-inner-icon="fa fa-pencil-alt"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            label="تعداد آگهی جدید"
            max="10"
            min="1"
            oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
            outlined
            type="number"
          />
        </div>
        <div class="col-md-6">
          <v-text-field
            v-model.number="newSchema['count']"
            :rules="[(v) => !!v || 'این فیلد الزامی است']"
            append-inner-icon="fa fa-pencil-alt"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            label="تعداد آگهی های من"
            max="10"
            min="1"
            oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
            outlined
            type="number"
          />
        </div>
      </div>
      <div class="col-md-10 mr-auto">
        <v-btn
          :disabled="!loading && !isConfirmed"
          :loading="loading"
          class="submit-btn float-left"
          @click="sendSmartAds"
        >
          <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
          ثبت نردبان هوشمند
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import InputMaker from "@/view/pages/ads/inputMaker";
import AdsSelector from "@/view/pages/ads/adsSelector";
import Inputs from "@/view/pages/ads/inputs";
import NumberSelector from "@/view/pages/ads/numberSelector";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import CitySelector from "@/view/pages/ads/citySelector";
import Categoryselector from "@/view/pages/ads/categorySelector";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import SimilarAds from "@/view/pages/ads/similarAds/similarAds";
import ownAds from "@/view/pages/ads/sendAds/ownAds";
import { Axios2, Bus } from "@/main";
import MultiTimes from "@/view/pages/ads/sendAds/multiTimes";
import TimrWithDays from "@/view/pages/ads/sendAds/timrWithDays";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import ShopAdsList from "@/view/pages/ladderShop/shopAdsList";
import GetPanelsNumber from "@/view/pages/ads/singleAds/agency/getPanelsNumber";
import AdsLIst from "@/view/pages/ads/panels/ladder/adsList";
import PayLadderComponent from "@/view/pages/ladderShop/payLadderComponent";

export default {
  name: "EstateGradual",

  components: {
    PayLadderComponent,
    AdsLIst,
    GetPanelsNumber,
    ShopAdsList,
    ButtonTempl,
    TimrWithDays,
    MultiTimes,
    SimilarAds,
    TitleRibbon,
    InputMaker,
    AdsSelector,
    Inputs,
    NumberSelector,
    Automatics,
    CitySelector,
    Categoryselector,
    ownAds,
  },
  props: {
    divar: {
      required: true,
    },
    own: {
      required: true,
    },
    ads: {
      required: true,
    },
    multi_time: {
      type: Boolean,
      default: false,
    },
    pageName: {
      type: String,
      default: "ارسال آگهی هوشمند",
    },
    cats: {
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      picker: "",
      count: [1],
      autoChange: false,
      requireAds: false,
      isSmart: true,
      payLadder: {
        wallet: true,
      },
      schema: {
        advertise: {
          category: "",
          location: {
            city: "",
            neighborhood: "",
          },
          images: [],
          contact: {
            chat_enabled: false,
            hide_phone: false,
            phone: null,
          },
        },
        available_at: "",
        expire_at: "",
      },
      multiTimes: {},
      newSchema: {
        type: "advertise",
        kind: "agency",
        search_payload: {},
        smart_payload: {
          is_agent: true,
        },
      },
      myCategory: "",
      isDay: false,
      selected: [],
      isConfirmed: false,
      marketNumber: "",
      numberId: "",
      marketNumberId: "",
      maxCount: "",
      invent: [],
      inventPhones: [],
      selectedInventPhones: [],
      advertises: [],
      icon: "mdi-checkbox-blank-outline",
      selectedNumber: undefined,
    };
  },
  mounted() {
    this.getInvent();
    this.newSchema.smart_payload["wallet"] = this.payLadder.wallet;

    Bus.$on("cityInfo", (value) => {
      (this.schema.advertise.location.city = value.city),
        (this.schema.advertise.location.neighborhood = value.neighborhood);
    });
    Bus.$on("category-current", (value) => {
      this.myCategory = value;
    });
    Bus.$on("getSimilarData", (value) => {
      this.newSchema.search_payload = value;
    });

    Bus.$on("rp_selected_number", (val) => {
      this.selectedNumber = val;
    });

    // Bus.$on("getTimeMode", (value, key) => {
    //     this.multiTimes[key] = value;
    // })

    Bus.$on("getDayMode", (values) => {
      this.newSchema["days"] = values.day;
      this.newSchema["start_time"] = values.start;
      this.newSchema["end_time"] = values.end;
    });

    Bus.$on("selected_numbers", (val) => {
      this.numberId = val;
    });

    Bus.$on("maxCountOfLadder", (value, key) => {
      this.maxCount = value.remaining;
    });

    Bus.$on("dialogRange", (name, value = null) => {
      this.newSchema.smart_payload[name] = value;
    });

    Bus.$on("selectedAds", (value, key) => {
      this.newSchema.smart_payload["advertises"] = value;
    });
  },
  watch: {
    isDay: function (value) {
      if (value === false) {
        Bus.$on("getDayMode", (values) => {
          this.newSchema["days"] = values.day;
          this.newSchema["start_time"] = values.start;
          this.newSchema["end_time"] = values.end;
        });
      } else if (value === true) {
        delete this.newSchema["days"];
        delete this.newSchema["start_time"];
        delete this.newSchema["end_time"];
        Bus.$on("getTimeMode", (moment) => {
          this.newSchema["expire_at"] = moment.end;
          this.newSchema["start_at"] = moment.started;
          // this.newSchema.smart_payload['repeat'] = moment.repeat;
        });
      }
    },
    isConfirmed(value) {
      if (value) {
        this.newSchema.smart_payload["number_id"] = this.numberId;
      }
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.selectedInventPhones.length === this.inventPhones.length) {
          this.selectedInventPhones = [];
          this.icon = "mdi-checkbox-blank-outline";
        } else {
          this.selectedInventPhones = this.inventPhones.map((item) => item.id);
          this.icon = "mdi-checkbox-marked";
        }
      });
    },
    getSchema: function (value) {
      this.ui_schema = value;
    },
    getFields: function (val) {
      this.fields = val;
    },
    removeDate(index) {
      this.count.splice(index, 1);
    },
    sendSmartAds(number = 0) {
      const keys = Object.keys(this.multiTimes);

      if (keys.length > 0)
        var param = {
          ...this.newSchema,
          start_at: this.multiTimes[keys[0]].started,
          expire_at: this.multiTimes[keys[0]].end,
        };

      this.loading = true;
      $.ajax({
        url: `${url}/smarts`,
        method: "POST",
        fn: this.sendSmartAds,
        params: [number],
        msg: true,
        headers: {
          ACCEPT: "application/json",
          "Content-Type": "application/json",
          Authorization: Token,
        },
        data: JSON.stringify(keys.length > 0 ? param : this.newSchema),
        success: (data) => {
          this.loading = false;
        },
        error: (data) => {
          this.loading = false;
        },
      }).always((data) => {
        number++;
        if (number < keys.length) this.sendSmartAds(number);
      });
    },
    syncMarketPlace() {
      this.isConfirmed = true;
      this.marketNumberId = this.numberId;
      this.marketNumber = "";
    },
    getInvent() {
      this.loading = true;
      $.ajax({
        url: `${url}/divar/agency/invent`,
        method: "GET",
        fn: this.sendSmartAds,
        msg: false,
        headers: {
          ACCEPT: "application/json",
          "Content-Type": "application/json",
          Authorization: Token,
        },
      }).then((data) => {
        this.loading = false;
        this.invent = data.data;
        this.getInventPhones();
      });
    },
    getInventPhones() {
      $.ajax({
        url: `${url}/divar/agency/invent/phones`,
        method: "POST",
        fn: this.sendSmartAds,
        msg: false,
        headers: {
          ACCEPT: "application/json",
          "Content-Type": "application/json",
          Authorization: Token,
        },
        data: JSON.stringify({
          ids: this.invent.map((item) => item.id),
        }),
      }).then((data) => {
        this.inventPhones = data.data.map((value) => {
          let user = this.invent.find((user) => user.id === value.user_id);
          return {
            ...value,
            name: user.name,
            family: user.family,
            pack: user?.pack?.id,
            text: user.name + " " + user.family + " - " + value.phone,
            value: value.id,
          };
        });
      });
    },
    async getAdvertises() {
      this.loading = true;
      this.advertises = [];

      for (const item of this.selectedInventPhones) {
        let request = await Axios2.get("/divar/agency/remaining/" + item);
        this.advertises.push(...request.data.data.data);
      }

      this.syncMarketPlace();
      this.loading = false;
    },
  },
  computed: {
    inventPanels() {
      return this.selectedInventPhones.map(
        (item) => this.inventPhones.find((phone) => phone.id === item).pack
      );
    },
  },
};
</script>

<style scoped></style>
